import { Component, OnInit } from '@angular/core';
import { EoptionsService } from 'src/app/services/eoptions.service';

@Component({
    selector: 'app-option-expiry',
    templateUrl: './option-expiry.component.html',
    styleUrls: ['./option-expiry.component.css']
})
export class OptionExpiryComponent implements OnInit {
    expiries: string[] = [];
    selectedExpiry: string = '';

    constructor(private eoptionsService: EoptionsService) { }

    ngOnInit(): void {
        this.eoptionsService.expiries$.subscribe(expiries => {
            this.expiries = expiries;
            if (expiries.length > 0 && !this.selectedExpiry) {
                this.selectedExpiry = expiries[0]; // Auto-select first
            }
        });
    }

    selectExpiry(expiry: string) {
        this.selectedExpiry = expiry;
        this.eoptionsService.selectExpiry(expiry);
    }
}
